module.exports = __webpack_public_path__ + "static/img/li1_10.fc97442d.png";